<template>
<div class="p-8 login-tabs-container">

  <h4 class="mb-8">{{ $t('message.register.newClientHeader') }}</h4>

  <div v-html="$t('message.register.registrationDone', {num: number})" />

</div>
</template>

<script>
export default {
  name: 'RegistrationDone',
  props: {
    'number':{}
  },
  data: () => ({
    agrement: false
  })
}
</script>

<style scoped>

</style>
